const oevo = {
  prepage: {
    headline: 'Die Glasversicherung der Öffentlichen',
    leistungenIntro: '',
    leistungen: [
      'Absicherung von Gebäude- und Mobilarverglasungen',
      'Unabhängig von der Schadenursache',
      'Erstattung von Mehr- und Folgekosten (z.B. Notverglasung)',
    ],
  },
  produktvergleich: {
    produkte: {
      mobiliar: `<h4>Mobiliarverglasung</h4>
        <p>Versichert sind Mobiliarverglasungen von Bildern, Schränken und Vitrinen, Stand-, Wand- und Schrankspiegeln, 
        Glasplatten, Glasscheiben und Sichtfenster von Öfen, Elektro- und Gasgeräten, Aquarien, Terrarien und 
        Glaskeramik-Kochflächen.</p>
        <p>Außerdem sind je Schadenfall bis jeweils 10.000 Euro mitversichert:</p>
        <ul class="list-icn-bar">
            <li>Verglasungen von privat genutzten Kleingewächshäusern und Abdeckungen von Schwimmbecken</li>
            <li>Künstlerisch bearbeitete Glasscheiben, -spiegel und -platten</li>
            <li>Sonderkosten für Gerüste, Kräne oder Ähnliches</li>
            <li>Beseitigung und Wiederanbringen von Hindernissen wie Markisen oder Schutzgitter</li>
            <li>Erneuerung von Anstrichen, Malereien, Schriften, Verzierungen, Folien</li>
            <li>Schäden an Umrahmungen, Mauerwerk, Schutzeinrichtungen</li>
            
        </ul>`,
      gebaeude: `<h4>Gebäudeverglasung<h4>
        <p>Versichert sind Gebäudeverglasungen von Fenstern, Türen, Balkonen, Terrassen, Wänden, Wintergärten, Veranden, 
        Loggien, Wetterschutzvorbauten, Dächern, Brüstungen, Duschkabinen, Lichtkuppeln, Sonnenkollektoren einschließlich 
        Rahmen, Glasbausteinen, Profilbaugläsern</p>
        <p>Außerdem sind je Schadenfall bis jeweils 10.000 Euro mitversichert:</p>
        <ul class="list-icn-bar">
            <li>Verglasungen von privat genutzten Kleingewächshäusern und Abdeckungen von Schwimmbecken</li>
            <li>Künstlerisch bearbeitete Glasscheiben, -spiegel und -platten</li>
            <li>Sonderkosten für Gerüste, Kräne oder Ähnliches</li>
            <li>Beseitigung und Wiederanbringen von Hindernissen wie Markisen oder Schutzgitter</li>
            <li>Erneuerung von Anstrichen, Malereien, Schriften, Verzierungen, Folien</li>
            <li>Schäden an Umrahmungen, Mauerwerk, Schutzeinrichtungen</li>
        </ul>`,
    },
  },
};

export default oevo;
